import {
  ADD_CUSTOMER_MUTATION_OPERATION_NAME,
  CANCEL_WRAPUP_MUTATION,
  INTERACTION_CLASSIFICATION_DATA_MUTATION,
  LINK_CALL_TO_CUSTOMER_AND_LOCATION_OPERATION_NAME,
  UPDATE_USER_AVAILABILITY_STATUS_MUTATION,
} from 'src/constants/operations';

export const retryableMutations = [
  UPDATE_USER_AVAILABILITY_STATUS_MUTATION,
  CANCEL_WRAPUP_MUTATION,
  INTERACTION_CLASSIFICATION_DATA_MUTATION,
  ADD_CUSTOMER_MUTATION_OPERATION_NAME,
  LINK_CALL_TO_CUSTOMER_AND_LOCATION_OPERATION_NAME,
];
